import { AppStorageKey } from '../types';
import { I18n, Store } from '../wrappers';
import { apiService } from './ApiService';
import { websocketsService } from './WebsocketsService';
import { appStorage } from '../utilities/AppStorage';
import AppService from './AppService';
import TenantService from './TenantService';
import UserService from './UserService';
import moment from 'moment-timezone';
class ConnectionService {
    connCheckInterval = undefined;
    isOnline = true;
    async setOnline() {
        Store.set('isOnline', true);
        if (this.isAppLocked()) {
            this.unlockApp();
        }
        this.deleteOfflineFromTimestamp();
        if (!this.isOnline) {
            const tenantToken = await TenantService.getToken();
            const userToken = await UserService.getToken();
            if (!tenantToken) {
                await UserService.removeToken();
                await UserService.removeUser();
                await TenantService.removeTenant();
            }
            else if (!userToken) {
                await UserService.removeUser();
            }
            websocketsService.reload();
        }
        this.isOnline = true;
        this.stopPeriodicConnectionCheck();
    }
    async setOffline() {
        Store.set('isOnline', false);
        this.isOnline = false;
        const offlineFrom = await this.getOfflineFromTimestamp();
        const offlineLimitMinutes = I18n.c('general.offlineMinutesLimit');
        if (!offlineFrom) {
            await this.setOfflineFromTimestamp();
        }
        else if (moment().diff(moment(offlineFrom), 'minutes') > offlineLimitMinutes) {
            this.lockApp();
        }
        this.startPeriodicConnectionCheck();
    }
    startPeriodicConnectionCheck() {
        clearInterval(this.connCheckInterval);
        this.connCheckInterval = setInterval(() => {
            this.connectionCheck();
        }, 20000);
    }
    stopPeriodicConnectionCheck() {
        clearInterval(this.connCheckInterval);
        this.connCheckInterval = undefined;
    }
    async connectionCheck() {
        try {
            await this.checkOnline();
            await AppService.sync();
            await this.setOnline();
            return true;
        }
        catch (error) {
            await this.setOffline();
            return false;
        }
    }
    /**
     * Send a an empty request to the server to check the connection
     */
    async checkOnline() {
        try {
            const response = await apiService.get('/check');
            if (!response || !response.data || !response.data.success) {
                throw Error('Client is offline');
            }
        }
        catch (error) {
            throw Error('Client is offline. ' + error.message);
        }
    }
    onDeviceOnline() {
        this.connectionCheck();
    }
    onDeviceOffline() {
        this.setOffline();
    }
    async setOfflineFromTimestamp() {
        appStorage.local().setItem(AppStorageKey.offlineFrom, moment().format('YYYY-MM-DD HH:mm:ss'));
    }
    async deleteOfflineFromTimestamp() {
        appStorage.local().deleteItem(AppStorageKey.offlineFrom);
    }
    async getOfflineFromTimestamp() {
        return appStorage.local().getItem(AppStorageKey.offlineFrom);
    }
    lockApp() {
        Store.set('lockedReason', 'offlineDuration');
    }
    unlockApp() {
        Store.set('lockedReason', null);
    }
    isAppLocked() {
        return Store.get('lockedReason') === 'offlineDuration';
    }
    async connectionCheckRetry(waitInMs) {
        const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
        await delay(waitInMs);
        const isOnline = await connectionService.connectionCheck();
        return isOnline;
    }
}
;
export const connectionService = new ConnectionService();
export default connectionService;
//# sourceMappingURL=ConnectionService.js.map